import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f26fbecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "huddle-detail-card" }
const _hoisted_2 = { class: "section section--top" }
const _hoisted_3 = { class: "panel panel--flight" }
const _hoisted_4 = { class: "flight-path" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "barbell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_6 = { class: "panel panel--goals" }
const _hoisted_7 = { class: "section section--bottom" }
const _hoisted_8 = { class: "panel panel--insights" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "panel panel--sales" }
const _hoisted_11 = { key: 1 }

import { computed } from 'vue'
import { Huddle } from '@/entities/huddles'
import HuddleDetailsTopicsPanel from '@/mobile/src/views/appV4/huddles/HuddleDetailsTopicsPanel.vue'
import HuddleDetailsSalesPanel from '@/mobile/src/views/appV4/huddles/HuddleDetailsSalesPanel.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'
import HuddlesMetric from '@/mobile/src/views/appV4/huddles/HuddlesMetric.vue'
import { palette } from '@/utils/palette'
import { formatNumber } from '@/utils/number'

interface Props {
    huddle: Huddle
    baseCxscoreGoal: number | undefined
    summaryView?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddleDetails',
  props: {
    huddle: {},
    baseCxscoreGoal: {},
    summaryView: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const goalComparison = computed(() => {
    const difference = props.huddle.cxscore - props.baseCxscoreGoal

    if (difference === 0) {
        return 'On goal'
    }

    const differenceLabel = formatNumber(difference, 1)
    return `${differenceLabel}% ${difference > 0 ? 'above' : 'below'} goal`
})

const salesPerHead = computed(() => {
    if (!props.huddle.sales_per_head_goal) {
        return '-'
    }
    return `$${Number(props.huddle.sales_per_head_goal).toFixed(2)} per head`
})

const hasTopicsData = computed(() => {
    return props.huddle.topics && props.huddle.topics.length > 0
})

const hasSaleData = computed(() => {
    return (
        props.huddle.top_selling_items &&
        props.huddle.top_selling_items.length > 0
    )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Typography, { variant: "caption" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.huddle.flight_number), 1)
          ], undefined, true),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.huddle.depart_station) + " ", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.huddle.arrival_station), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (
                        _ctx.huddle.cx_stat_summary &&
                        _ctx.huddle.cx_stat_summary?.total === 0
                    )
          ? (_openBlock(), _createBlock(HuddlesMetric, {
              key: 0,
              "top-label": "CSAT",
              "metric-value": 'N/A',
              "bottom-label": 'No flight data available',
              "value-color": _unref(palette).successGreen
            }, null, 8, ["value-color"]))
          : (_openBlock(), _createBlock(HuddlesMetric, {
              key: 1,
              "top-label": "CSAT",
              "metric-value": `${_ctx.huddle.cxscore}%`,
              "bottom-label": goalComparison.value,
              "value-color": _unref(palette).successGreen
            }, null, 8, ["metric-value", "bottom-label", "value-color"])),
        _createVNode(HuddlesMetric, {
          "top-label": "Sales Goal",
          "metric-value": `$${_ctx.huddle.revenue_goal}`,
          "bottom-label": salesPerHead.value,
          "value-color": _unref(palette).successGreen
        }, null, 8, ["metric-value", "bottom-label", "value-color"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (hasTopicsData.value)
          ? (_openBlock(), _createBlock(HuddleDetailsTopicsPanel, {
              key: 0,
              topics: _ctx.huddle.topics,
              "base-cxscore-goal": _ctx.baseCxscoreGoal,
              "summary-view": _ctx.summaryView
            }, null, 8, ["topics", "base-cxscore-goal", "summary-view"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "No insights data available on this flight"))
      ]),
      _createElementVNode("div", _hoisted_10, [
        (hasSaleData.value)
          ? (_openBlock(), _createBlock(HuddleDetailsSalesPanel, {
              key: 0,
              "top-selling-items": _ctx.huddle.top_selling_items,
              "summary-view": _ctx.summaryView
            }, null, 8, ["top-selling-items", "summary-view"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, "No sales data available on this flight"))
      ])
    ])
  ]))
}
}

})